<script>
import appConfig from "@/app.config";
export default {
    data: () => ({
        assetsPath: appConfig.assetsPath,
    })
}
</script>

<template>
    <div>
        <!-- Modal -->
        <b-modal
        id="chinese-tv-dailog"
        scrollable
        title="Scrollable Content"
        modal-class="fullscreen-modal"
        hide-footer
        header-class="careers-modal-header"
        >
        <template v-slot:modal-header="{ close }">
            <b-container class="p-rel">
            <div class="d-flex justify-content-between">
                <img :src="assetsPath + 'images/drPanda-logo.svg'" :class="$style.modalLogo" />

                <svg
                class="ham hamRotate ham1 active"
                viewBox="0 0 100 100"
                width="80"
                :class="$style.closeIcon"
                @click="close()"
                >
                <path
                    class="line blackLine top"
                    d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
                />
                <path class="line blackLine middle" d="m 30,50 h 40" />
                <path
                    class="line blackLine bottom"
                    d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
                />
                </svg>
            </div>
            </b-container>
        </template>
        <div class="d-inline-block w-100" >
            <b-container>
            <div :class="$style.chineseTvBlock" class="pl-0 pr-0">
                <h2 class="heading-2 text-center">{{$t('chineseTvButtons.title')}}</h2>
                <div :class="$style.centerBlock">
                <a href="http://i.youku.com/u/UNTIxMTA5NzI1Ng==?spm=a2h0c.8166622.PhoneSokuPgc_1.dportrait" target="_blank"><button class="btn btn-x btn-pink"> <img :src="assetsPath + 'images/yk-logo.svg'"  /> <span>{{$t('chineseTvButtons.youku')}}</span></button></a>
                <a href="https://www.iqiyi.com/u/1676091136/videos" target="_blank"><button class="btn btn-x btn-green"> <img :src="assetsPath + 'images/qiy-logo.svg'"  /> <span>{{$t('chineseTvButtons.iQ')}}</span></button></a>
                <a href="https://v.qq.com/vplus/9620e9516071c8dce7db6985fbb6bbc6#uin=9620e9516071c8dce7db6985fbb6bbc6?page=video" target="_blank"><button class="btn btn-x btn-sky-blue"> <img :src="assetsPath + 'images/tencent-logo.svg'"  /> <span>{{$t('chineseTvButtons.tencent')}}</span></button></a>
                </div>
            </div>
            </b-container>
        </div>
        </b-modal>
    <!-- / Modal -->
        <b-modal
            id="weChat-qrcode-modal"
            scrollable
            title="Scrollable Content"
            modal-class="fullscreen-modal"
            hide-footer
            header-class="careers-modal-header"
        >
            <template v-slot:modal-header="{ close }">
                <b-container class="p-rel">
                    <div class="d-flex justify-content-between">
                        <img :src="assetsPath + 'images/drPanda-logo.svg'" :class="$style.modalLogo" />

                        <svg
                        class="ham hamRotate ham1 active"
                        viewBox="0 0 100 100"
                        width="80"
                        :class="$style.closeIcon"
                        @click="close()"
                        >
                        <path
                            class="line blackLine top"
                            d="m 30,33 h 40 c 0,0 9.044436,-0.654587 9.044436,-8.508902 0,-7.854315 -8.024349,-11.958003 -14.89975,-10.85914 -6.875401,1.098863 -13.637059,4.171617 -13.637059,16.368042 v 40"
                        />
                        <path class="line blackLine middle" d="m 30,50 h 40" />
                        <path
                            class="line blackLine bottom"
                            d="m 30,67 h 40 c 12.796276,0 15.357889,-11.717785 15.357889,-26.851538 0,-15.133752 -4.786586,-27.274118 -16.667516,-27.274118 -11.88093,0 -18.499247,6.994427 -18.435284,17.125656 l 0.252538,40"
                        />
                        </svg>
                    </div>
                </b-container>
            </template>
            <div class="d-inline-block w-100" >
                <b-container>
                    <div :class="$style.chineseTvBlock" class="pl-0 pr-0">
                        <div class="text-center"> 
                            <img :src="assetsPath + 'images/wechat-qr-code.png'" :class="$style.wechatQr" />
                        </div>
                    </div>
                </b-container>
            </div>
        </b-modal>
    </div>
</template>

<style lang="scss" module>
@import "src/design/index.scss";


.closeIcon{
  width: 60px;
  position: absolute;
  right: 0;
  top: 0;
}
.modalLogo {
 width: 70px;
}
.chineseTvBlock{
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  h2{
    margin-bottom: 50px;
  }
  .centerBlock{
    width: 300px;
    margin: 0 auto;
    max-width: 100%;
    a{
      margin-bottom: 20px;
      display: inline-block;
      width: 100%;
      button{
        width: 100%;
        min-width: 100%;
        img{
          margin-right: 20px;
        }
      }
    }
  }
}
.wechatQr{

}
</style>